import axios, { AxiosResponse } from "axios";
import { WebAPI, IFailCallbackParam } from "../constants";
import { getErrorStatus } from "./getErrorStatus";
import AuthService from "../../common/AuthService";

interface ICallbackParams extends IFailCallbackParam {
  /**
   * WebAPIでモデル評価実行が成功した場合に呼び出されます
   * @callback success
   * @param {number} status - httpステータス
   */
  success: (status: number) => void;
}

export interface IEvaluateModelRequestModel {  
  /**
   * モデル評価設定（Auto/Custom）
   */
  mode: string;
}

function AxiosPost(
  url: string,
  params: IEvaluateModelRequestModel,
  token?: string
) {
  if (token) {
    return axios.post(url, JSON.stringify(params), {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    });
  } else {
    return axios.post(url, JSON.stringify(params), {
      headers: { "Content-Type": "application/json" },
    });
  }
}

interface IAxiosInternalParams extends ICallbackParams {
  promise: Promise<AxiosResponse>;
}

function AxiosInternal(params: IAxiosInternalParams) {
  params.promise
    .then((res) => {
      params.success(res.status);
    })
    .catch((err) => {
      const { id, status } = getErrorStatus(err);
      params.fail(id, status);
    });
}

export interface IEvaluateModelParams
  extends IEvaluateModelRequestModel,
    ICallbackParams {
  /**
   * 認証オブジェクト
   */
  authService?: AuthService;
  /**
   * プロジェクトID
   */
  projectid: string;
}

/**
 * モデルの評価を実行します
 * @function evaluateModel
 * @param {IEvaluateModelParams} params - モデル評価実行パラメータ
 */
export function evaluateModel(params: IEvaluateModelParams): void {
  const { authService, projectid, mode } = params;  
  const req: IEvaluateModelRequestModel = {
    mode: mode,
  }
  const url = WebAPI.EVALUATION_MODEL(projectid);
  if (authService) {
    authService.getToken({
      success: (token) => {
        AxiosInternal({
          promise: AxiosPost(url, req, token),
          success: params.success,
          fail: (id, status) => {
            if (status === 401) {
              evaluateModelRetry401(authService, url, req, params);
            } else {
              params.fail(id, status);
            }
          },
        });
      },
      fail: (err) => {
        const { id, status } = getErrorStatus(err);
        params.fail(id, status);
      },
    });
  } else {
    AxiosInternal({
      promise: AxiosPost(url, req),
      success: params.success,
      fail: params.fail,
    });
  }
}

/**
 * モデルの評価を実行します
 * @function evaluateModelRetry401
 * @param {AuthService} authService - 認証オブジェクト
 * @param {string} url - リクエストURL
 * @param {IEvaluateModelRequestModel} req - リクエストパラメータ
 * @param {ICallbackParams} params - コールバックパラメータ
 */
export function evaluateModelRetry401(
  authService: AuthService,
  url: string,
  req: IEvaluateModelRequestModel,
  params: ICallbackParams
): void {
  authService.updateToken({
    success: (token) => {
      AxiosInternal({
        promise: AxiosPost(url, req, token),
        success: params.success,
        fail: params.fail,
      });
    },
    fail: (err) => {
      const { id, status } = getErrorStatus(err);
      params.fail(id, status);
    },
  });
}